import { ProductFiltersGridView } from '~/components/catalog/filters/grid';
import { PageContainer } from '~/components/page-container';

export function Filters() {
	return (
		<PageContainer>
			<ProductFiltersGridView />
		</PageContainer>
	);
}
